import Clock from "./components/clock";
import { Button } from "antd";
import CheckoutConfirmationModal from "./components/checkout-confirmation-modal.view";
import React, { useEffect, useRef, useState } from "react";
import dashboard from "../../../resources/dashboard";
import dayjs from 'dayjs';
import '../../../styles/component/dashboard/employee-punch-card.scss';
import { getTimeDiffInHHmm } from "../../../utility/utility";

interface IModalState {
    isOpen: boolean,
    data: { time: string, duration: string } | null
}

interface EmployeePunchCardViewProps {
    handleCheckIn: () => void;
    handleCheckout: () => void;
    isCheckedIn: boolean;
    punchStatus: {
        time: string,
        punchDateTime: string
    };
    isLoading: boolean;
}

const EmployeePunchCardView = (props: EmployeePunchCardViewProps) => {

    const todayDate = new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
    const todayDay = new Date().toLocaleDateString("en-US", {
        weekday: "long",
    });
    const resources = dashboard.attendanceWidget.EmployeeAttendanceWidget;
    const [modalState, setModalState] = useState<IModalState>({
        isOpen: false,
        data: null
    });
    const currentStatus = props.isCheckedIn ? resources.checkIn : resources.checkOut;
    const [durationPassed, setDurationPassed] = useState("");
    const intervalRef = useRef<number | null>(null);

    useEffect(() => {
        setDurationPassed(getTimeDiffInHHmm(props.punchStatus.punchDateTime));

        // Update every minute
        intervalRef.current = window.setInterval(() => {
            setDurationPassed(getTimeDiffInHHmm(props.punchStatus.punchDateTime));
        }, 60 * 1000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [props.punchStatus.punchDateTime]);


    function handleSubmitBtn(e?: React.MouseEvent) {
        e?.stopPropagation();
        if (props.isCheckedIn) {
            onModalOpen();
        } else {
            props.handleCheckIn()
        }
    }

    function onModalOpen(e?: React.MouseEvent) {
        setModalState({
            data: {
                time: props.punchStatus.time,
                duration: durationPassed
            },
            isOpen: true
        })
    }

    function onModalClose(e?: React.MouseEvent) {
        e?.stopPropagation();
        setModalState((prev) => ({
            ...prev,
            isOpen: false,
            data: null
        }))
    }


    return (
        <div className={"dashboard-card dashboard-punch-card"}>
            <p className={"dashboard-punch-card__today-date"}><b>{todayDate}</b></p>
            <Clock/>
            <p className={"dashboard-punch-card__today-day"}>{todayDay}</p>

            <div className="dashboard-punch-card__employee-punch-details">
                <div className="status-section">
                <span
                    className={`status-indicator ${currentStatus.status}`}/>
                    <span
                        className={"status-title"}>{currentStatus.title}</span>
                    <div className="status-row">
                    <span
                        className="status-label">{currentStatus.lastLabel}</span>
                        <span className="status-value">
                        <span className="time-badge"
                              id="lastCheckoutTime"
                        >
                            {props.punchStatus.time}
                        </span>
                    </span>
                    </div>
                    <div className="status-row">
                    <span className="status-label">
                        {currentStatus.timeLabel}
                    </span>
                        <span className="status-value">
                        <span className="duration-badge"
                              id="checkoutDuration"
                        >
                          {durationPassed}
                        </span>
                    </span>
                    </div>
                </div>

                <Button
                    onClick={(e) => {
                        e.stopPropagation();
                        handleSubmitBtn();
                    }}
                    loading={props.isLoading}
                    type="primary"
                    className={`${currentStatus.status}`}
                >
                    {currentStatus.buttonText}
                </Button>

                <CheckoutConfirmationModal
                    open={modalState.isOpen}
                    onCancel={onModalClose}
                    onOk={props.handleCheckout}
                    snapshot={modalState.data}
                />
            </div>

        </div>
    )
}

export default EmployeePunchCardView;
